export default __webpack_public_path__ + "assets/images/High-Commissions-84e8fda67c86eddc42bae4702b4fab1b.svg";